<!-- eslint-disable no-console -->
<template>
    <div>
        <div class="row">
            <div class="col"><button @click="goBack()" class="btn btn-secondary m-3">Back</button></div>
        </div>
        <div class="row align-items-center m-3">
            <div class="col">
                <div>
                    <p class="h1 t-race">{{ this.getReportName }}</p>
                </div>
            </div>
        </div>
        <div class="row align-items-center m-3">
            <div class="col">
                <div>

                    <div class="dropdown show">
                        <a class="btn btn-secondary dropdown-toggle" @click="toggleDropdown()" href="#" role="button"
                            id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            EXPORT
                        </a>

                        <div v-bind:class="dropdownToggle" aria-labelledby="dropdownMenuLink">

                            <a @click="openLink('CSV')" class="dropdown-item" href="#">CSV</a>
                            <a @click="openLink('XL')" class="dropdown-item" href="#">Excel</a>

                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class= "row align-items-center m-3">
            <div class="square red"></div>
            <p class="labels">Fastest</p>
            <div class="square orange"></div>
            <p class="labels">2nd Fastest</p>
            <div class="square yellow"></div>
            <p class="labels">3rd Fastest</p>
        </div>
        <div class=" displayBox table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Draw</th>
                        <th>Horse Name</th>
                        <th>Weight</th>

                       
                        <th colspan="2" v-for="item in getHeadersArray()" :key="item">
                            {{ item == "Start" || item == "Finish" ? `${item}` : `${item}` }}
                        </th>
                        <th>Race Time</th>
                        <th>800-400m</th>
                        <th>400m-finish</th>
                      
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in getViewData()" :key="index">
                        <td :style="{ 'background-color': horseData.Colour }" v-for="(horseData, i) in item" :key="i">
                            <template v-if="horseData.isGroup">

                                <div class="horse-details">
                                    <div class="horse-name-area">
                                        {{ horseData.value }}
                                    </div>
                                    <div class="trainer-jockey-area">
                                        <div class="trainer">
                                            {{ horseData.groupValues.Jockey }}
                                            {{ horseData.groupValues.Trainer == null ? '' : '/' }}
                                            {{ horseData.groupValues.Trainer }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                {{ horseData.value }}
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>





    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { config } from '../../config';

export default {
    name: "PositionAndTimeReport",
    data() {
        return {
            dropdownToggle: 'dropdown-menu',
            dropdownStatus: false
        }

    },
    methods: {
        goBack() {
            this.$router.push('/landing/SectoionalPositionAndTimeFilter');
        },
        convertTime(timeStr) {
            if (typeof timeStr === 'string' || timeStr instanceof String) {
                return parseFloat(timeStr.replace(/:/g, '.')).toFixed(3);
            } else {
                return timeStr;
            }
        },
        getColourStyling(horse, section) {
    var RelevantSectionalData = this.getReportPostionBehindData.filter(z => z.section == section);

    RelevantSectionalData.forEach(entry => {
        entry.times = this.convertTime(entry.times);
    });

    RelevantSectionalData = RelevantSectionalData.sort((a, b) => parseFloat(a.times) - parseFloat(b.times));
    
    var colors = [];
    var coloredHorses = 0;
    var colorIndex = 0;
    
    for (let i = 0; i < RelevantSectionalData.length; i++) {
        if (coloredHorses === 3) {
            break; 
        }
        
        const currentHorse = RelevantSectionalData[i].horse;
        
        if (!colors.includes(currentHorse)) {
            colors.push(currentHorse);
            coloredHorses++;
            
            if (currentHorse === horse) {
                if (colorIndex === 0) {
                    return "red";
                } else if (colorIndex === 1) {
                    return "orange";
                } else if (colorIndex === 2) {
                    return "yellow";
                }
            }
            
            colorIndex++;
        }
    }

    return "white"; 
},

        getViewData() {

            var retData = [];
            var horses = new Set(this.getReportPostionBehindData.map(a => a.horse))
            var raceSectionals = new Set(this.getReportPostionBehindData.map(a => a.section));
            var tempData = [];
            var horseData = [];
            var tempRecord = null;
            horses.forEach(a => {

                horseData = this.getReportPostionBehindData.filter(ab => ab.horse == a);
                tempRecord = horseData.filter(sec => sec.horse == a)[0];
                tempData.push({
                    "value": tempRecord.draw,
                    "Colour": "white",
                    "isGroup": false
                });
                tempData.push({
                    "value": a,
                    "Colour": "white",
                    "isGroup": true,
                    "groupValues": {
                        "Jockey": tempRecord.jockey,
                        "Trainer": tempRecord.trainer
                    }
                });
                tempData.push({
                    "value": tempRecord.weight,
                    "Colour": "white",
                    "isGroup": true,
                    "groupValues": {
                        "Jockey": tempRecord.weightAllowed,
                        "Trainer": null
                    }
                });

                horseData = this.getReportPostionBehindData.filter(ab => ab.horse == a);
                raceSectionals.forEach(z => {
                    tempRecord = horseData.filter(sec => sec.section == z.toString())[0];

                    if (tempRecord != null) {
                        tempData.push({
                            "value": tempRecord.times,
                            "Colour": this.getColourStyling(a, z),
                            "isGroup": false
                        });
                        tempData.push({
                            "value": tempRecord.pos,
                            "Colour": this.getColourStyling(a, z),
                            "isGroup": false
                        });
                    } else {
                        tempData.push({
                            "value": "NA",
                            "Colour": "white",
                            "isGroup": false
                        });
                        tempData.push({ "value": "NA", "Colour": "white", "isGroup": false });
                    }

                });

                // console.log("TempRec: "+ tempRecord.TotalRaceTime)

                tempData.push({
                    "value": tempRecord.totalRaceTime,
                    "Colour": "white",
                    "isGroup": false
                });

                tempData.push({
                    "value": tempRecord.amal800_400,
                    "Colour": "white",
                    "isGroup": false
                });
                tempData.push({
                    "value": tempRecord.amal400_finish,
                    "Colour": "white",
                    "isGroup": false
                });

              

                retData.push(tempData);
                tempData = [];
                horseData = [];
                tempRecord = null;
            })



            return retData;




        },
        getHeadersArray() {

            this.getViewData();

            return new Set(this.getReportPostionBehindData.map(a => a.section));



        },
        toggleDropdown() {
            this.dropdownStatus = !this.dropdownStatus;
            this.dropdownToggle = this.dropdownStatus ? "dropdown-menu show" : "dropdown-menu";
        },
        openLink(fileType) {
            var a = this.getReportPostionBehindData[0].meetingDate
            window.open(`${config.reportingURL}/api/Reports/PositionalFile?SelectedDate=${a.substring(0, 2)}-${a.slice(3, 5)}-${a.slice(6, 10)}&RaceCourse=${this.getReportPostionBehindData[0].raceCourse}&rn=${this.getReportPostionBehindData[0].raceNumber}&fileType=${fileType}`, '_blank');


        }
    },
    computed: {
        ...mapGetters([
            'getReportPostionBehindData', 'getReportName'
        ])
    }
}
</script>


<style scoped>
.horse-details {
    display: flex;
    flex-direction: column;
}

.trainer-jockey-area {
    display: flex;
    flex-direction: row;
    font-style: italic;
    color: grey;
    margin-inline: auto;

}

.trainer,
.jockey {
    padding-inline: 0.3rem;
    font-size: 0.69rem;
}

.trainer {
    padding-right: 0.5rem;
}

.displayBox {
    max-height: 80vh;
    width: 95%;
    overflow: scroll;
    margin-inline: auto;

}

th {
    color: white !important;
    text-align: center;
    font-weight: bold;
    background-color: #4CAEE3 !important;
}

tr:hover {
    background-color: black !important;
    color: purple;
}

td {
    border-inline: 1px solid grey;
    padding: 0px;
    padding-inline: 0.5rem;
}

.t-race {
    text-align: center;
}

td {
    text-align: center;
}

.container {
    width: 100% !important;
}

.square {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    margin-left: 16px;
    margin-top: -10px; 
}

.red {
    background-color: red;
}

.yellow {
    background-color: yellow;
}

.orange {
    background-color: orange;
}

.labels{
    display: inline-block;
    font-size: medium;
}

tr:last-child {
    border-bottom: 1px solid black;
}</style>